export enum ChartType {
  HorizontalBarChart = 'HorizontalBarChart',
  PieChart = 'PieChart',
  VerticalBarChart = 'VerticalBarChart'
}
